import React, { useState } from 'react';
import { Container, Button, Typography, Box, Alert } from '@mui/material';
import { CustomTextField } from '../components/Inputs';
import { STPButton } from '../components/Botones';
import { sendPassRecovererMail } from '../services/sendPassRecoverMail';
import Logo from '../assets/Logo_Color_Training.png';
import { useNavigate } from 'react-router-dom';

export const PasswordRecovery = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(email)) {
      setError('Por favor ingresa un correo electrónico válido.');
      return;
    }
    setSubmitted(true);
    setError('');
    
    sendPassRecovererMail(email)
      .then(() => {
        setSubmitted(true);
      })
      .catch(() => {
        setError('No se pudo enviar el correo. Por favor, intenta de nuevo.');
      });
  };

  const handleEmailChange = (email) => {
    setError('');
    setEmail(email);
  }

  return (
    <Container sx={{ height: "100vh"}}>
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          mt: 8,
          mb: 5,
          }}>
          <img src={Logo} onClick={() => navigate('/login')} alt="VilaTraining Logo" style={{ height: '100px' }} />
        </Box>
      <Box textAlign="center" mb={3}>
        
        <Typography variant="h5" component="h1">
          <b>Recuperar Contraseña</b>
        </Typography>
      </Box>
      <form onSubmit={(e) => handleSubmit(e)} style={{ maxWidth: '90%', display: 'flex', flexDirection: 'column', margin: 'auto' }}>
        <CustomTextField
          label="Correo Electrónico"
          variant="outlined"
          margin="normal"
          value={email}
          onChange={(e) => handleEmailChange(e.target.value)}
        />
        {error && <Alert severity="error">{error}</Alert>}
        <Box mt={2} sx={{ display: 'flex', justifyContent: 'center' }}>
          <STPButton type="submit" variant="contained" color="primary" sx={{ width: "70%" }}>
            Enviar
          </STPButton>
        </Box>
      </form>
      {submitted && (
        <Box mt={3}>
          <Alert severity="success">Si el correo está registrado, recibirás un enlace para restablecer tu contraseña.</Alert>
        </Box>
      )}
    </Container>
  );
};